/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PaymentPage = lazyLoad(
  () => import('./index'),
  module => module.PaymentPage
);
